const colorNames = ["iconRed", "iconOrange", "iconYellow", "iconGreen", "iconBlue", "iconPurple", "iconMono"];

export default colorNames;
